// extracted by mini-css-extract-plugin
export var card = "_pf-0";
export var content = "_pf-2";
export var details = "_pf-3";
export var icon = "_pf-1";
export var iconBlue = "_pf-5";
export var iconBrand = "_pf-4";
export var iconGrayBlue = "_pf-6";
export var iconGreen = "_pf-7";
export var iconIndigo = "_pf-8";
export var iconOrange = "_pf-9";
export var iconPurple = "_pf-a";
export var iconRed = "_pf-b";
export var iconWarning = "_pf-c";